import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labsTooltipTitle: string;
    labsTooltipDetails: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            labsTooltipTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DialogHeader.labsTooltipTitle?c=p10soae5wgvn", defaultMessage: "This feature is in early development and may change or be discontinued." }));
                },
                enumerable: true,
                configurable: true
            },
            labsTooltipDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DialogHeader.labsTooltipDetails?c=3e3bk0xa6n3ym", defaultMessage: "Click to Submit Feedback" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
